// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .markdown-paragraph {
 margin-bottom: 20px;
 color: #333;
 font-family: 'Inter', sans-serif;
 font-size: 14px;
 font-style: normal;
 font-weight: 500;
 line-height: 22px; 
}

.markdown-heading1 {
 font-size: 28px;
 font-weight: bold;
 margin-top: 20px;
 margin-bottom: 10px;
 font-family: 'Inter', sans-serif;
}

.markdown-heading2 {
 font-size: 24px;
 font-weight: bold;
 margin-top: 20px;
 margin-bottom: 10px;
 font-family: 'Inter', sans-serif;
}

.markdown-heading3 {
 font-size: 20px;
 font-weight: bold;
 margin-top: 20px;
 margin-bottom: 10px;
 font-family: 'Inter', sans-serif;
}

.markdown-heading4 {
 font-size: 18px;
 font-weight: bold;
 margin-top: 16px;
 margin-bottom: 8px;
 font-family: 'Inter', sans-serif;
}

.markdown-heading5 {
 font-size: 16px;
 font-weight: bold;
 margin-top: 16px;
 margin-bottom: 8px;
 font-family: 'Inter', sans-serif;
}

.markdown-heading6 {
 font-size: 14px;
 font-weight: bold;
 margin-top: 16px;
 margin-bottom: 8px;
 font-family: 'Inter', sans-serif;
}

.markdown-unordered-list {
 list-style-type: disc;
 margin-left: 40px;
 margin-bottom: 20px;
}

.markdown-ordered-list {
 list-style-type: decimal;
 margin-left: 25px;
 margin-bottom: 20px;
}

.markdown-list-item {
 margin-bottom: 8px;
 color: #333;
 font-family: 'Inter', sans-serif;
 font-size: 14px;
 font-style: normal;
 font-weight: 500;
 line-height: 22px; 
}

.markdown-link {
 color: #0077cc;
 text-decoration: underline;
}

.markdown-code-block {
 background-color: #f5f5f5;
 padding: 10px;
 border: 1px solid #ccc;
 border-radius: 5px;
 overflow-x: auto;
}

.markdown-inline-code {
 background-color: #f5f5f5;
 padding: 2px 4px;
 border: 1px solid #ccc;
 border-radius: 3px;
 font-family: 'Inter', sans-serif;
}

.markdown-blockquote {
 background-color: #f9f9f9;
 border-left: 4px solid #0077cc;
 padding: 10px;
 margin: 10px 0;
}

.markdown-image {
 max-width: 100%;
 height: auto;
 display: block;
 margin: 0 auto; 
}

.markdown-table-header {
 background-color: #0077cc;
 color: white;
 padding: 8px;
}

.markdown-table-cell {
 border: 1px solid #ccc;
 padding: 8px;
}


@media (max-width: 768px) {
  .markdown-paragraph {
    font-size: 14px;
   }

.markdown-heading1 {
  font-size: 23px;
  margin-top: 15px;
  margin-bottom: 5px;
 }
 
 .markdown-heading2 {
  font-size: 20px;
  margin-top: 15px;
  margin-bottom: 5px;
 }
 
 .markdown-heading3 {
  font-size: 15px;
  margin-top: 15px;
  margin-bottom: 5px;
 }
 
 .markdown-heading4 {
  font-size: 13px;
  margin-top: 13px;
  margin-bottom: 5px;
 }
 
 .markdown-heading5 {
  font-size: 10px;
  margin-top: 15px;
  margin-bottom: 5px;
 }
 
 .markdown-heading6 {
  font-size: 8px;
  margin-top: 10px;
  margin-bottom: 5px;
 }
 
 .markdown-list-item {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 25px;
 }
 
}
 */
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ai-chat-bot/markdownRenderer.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+KE","sourcesContent":["/* .markdown-paragraph {\n margin-bottom: 20px;\n color: #333;\n font-family: 'Inter', sans-serif;\n font-size: 14px;\n font-style: normal;\n font-weight: 500;\n line-height: 22px; \n}\n\n.markdown-heading1 {\n font-size: 28px;\n font-weight: bold;\n margin-top: 20px;\n margin-bottom: 10px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-heading2 {\n font-size: 24px;\n font-weight: bold;\n margin-top: 20px;\n margin-bottom: 10px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-heading3 {\n font-size: 20px;\n font-weight: bold;\n margin-top: 20px;\n margin-bottom: 10px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-heading4 {\n font-size: 18px;\n font-weight: bold;\n margin-top: 16px;\n margin-bottom: 8px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-heading5 {\n font-size: 16px;\n font-weight: bold;\n margin-top: 16px;\n margin-bottom: 8px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-heading6 {\n font-size: 14px;\n font-weight: bold;\n margin-top: 16px;\n margin-bottom: 8px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-unordered-list {\n list-style-type: disc;\n margin-left: 40px;\n margin-bottom: 20px;\n}\n\n.markdown-ordered-list {\n list-style-type: decimal;\n margin-left: 25px;\n margin-bottom: 20px;\n}\n\n.markdown-list-item {\n margin-bottom: 8px;\n color: #333;\n font-family: 'Inter', sans-serif;\n font-size: 14px;\n font-style: normal;\n font-weight: 500;\n line-height: 22px; \n}\n\n.markdown-link {\n color: #0077cc;\n text-decoration: underline;\n}\n\n.markdown-code-block {\n background-color: #f5f5f5;\n padding: 10px;\n border: 1px solid #ccc;\n border-radius: 5px;\n overflow-x: auto;\n}\n\n.markdown-inline-code {\n background-color: #f5f5f5;\n padding: 2px 4px;\n border: 1px solid #ccc;\n border-radius: 3px;\n font-family: 'Inter', sans-serif;\n}\n\n.markdown-blockquote {\n background-color: #f9f9f9;\n border-left: 4px solid #0077cc;\n padding: 10px;\n margin: 10px 0;\n}\n\n.markdown-image {\n max-width: 100%;\n height: auto;\n display: block;\n margin: 0 auto; \n}\n\n.markdown-table-header {\n background-color: #0077cc;\n color: white;\n padding: 8px;\n}\n\n.markdown-table-cell {\n border: 1px solid #ccc;\n padding: 8px;\n}\n\n\n@media (max-width: 768px) {\n  .markdown-paragraph {\n    font-size: 14px;\n   }\n\n.markdown-heading1 {\n  font-size: 23px;\n  margin-top: 15px;\n  margin-bottom: 5px;\n }\n \n .markdown-heading2 {\n  font-size: 20px;\n  margin-top: 15px;\n  margin-bottom: 5px;\n }\n \n .markdown-heading3 {\n  font-size: 15px;\n  margin-top: 15px;\n  margin-bottom: 5px;\n }\n \n .markdown-heading4 {\n  font-size: 13px;\n  margin-top: 13px;\n  margin-bottom: 5px;\n }\n \n .markdown-heading5 {\n  font-size: 10px;\n  margin-top: 15px;\n  margin-bottom: 5px;\n }\n \n .markdown-heading6 {\n  font-size: 8px;\n  margin-top: 10px;\n  margin-bottom: 5px;\n }\n \n .markdown-list-item {\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 25px;\n }\n \n}\n */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
